/**
 * @file document-access.ts
 * @description Кто видит документы магазина: счета, УПД, акты (phase19.24
 * этап 1, шаг 5; находка повторного ревью 2026-09-21).
 *
 * Сервер пускает к документам по ЛЮБОМУ из трёх прав — так же, как реестр
 * узлов «Пути заказа» (`orders/chain/order-chain-access.ts`,
 * `ORDER_CHAIN_NODE_PERMISSIONS.INVOICE`). Клиент же проверял только
 * `SHOP_VIEW_DOCUMENTS`, и роль с `SHOP_USE_CRM` видела в «Пути заказа»
 * ссылку на счёт, а во вкладке «Оплаты и документы» — пустоту.
 *
 * Разрез лежит одной записью, а не тремя `useHasPermission` по месту: список
 * прав меняется в каталоге ролей целиком, и три копии разъедутся.
 */

import { useCurrentContext } from "../auth/hooks";

/** Достаточно любого из прав — как на сервере (OR, а не AND). */
export const DOCUMENT_VIEW_PERMISSIONS = [
  "SHOP_VIEW_DOCUMENTS",
  "SHOP_ISSUE_DOCUMENTS",
  "SHOP_USE_CRM",
] as const;

/** Право выставлять и проводить документы (создание счёта из заказа). */
export const DOCUMENT_ISSUE_PERMISSION = "SHOP_ISSUE_DOCUMENTS";

/** Видит ли роль с такими правами список документов. */
export function canViewDocuments(permissions: readonly string[]): boolean {
  return DOCUMENT_VIEW_PERMISSIONS.some((p) => permissions.includes(p));
}

/** Тот же разрез для компонентов: `canViewDocuments` по активному контексту. */
export function useCanViewDocuments(): boolean {
  const ctx = useCurrentContext();
  return canViewDocuments(ctx?.role.permissions ?? []);
}
